export default __webpack_public_path__ + "static/media/04AW3APR66.a96b9487.jpg";